export enum FragmentType {
    Dialog = 'Диалог',
    HeroDescription = 'Описание героя',
    PlaceDescription = 'Описание места',
    ReflectionsOrReasoning = 'Размышления/Рассуждения',
    ActionDescription = 'Описание действия',
}

export default class Fragment {
    constructor(
        public id:string, 
        public projectId:string, 
        public partId:string, 
        public type:FragmentType,
        public description:string,
        public members:string[],
        public places:string[],
        public objects:string[],
        public finishContent:string,
    ) {}
}
